export default "__VITE_ASSET__Dy1e3P$T__"